export default __webpack_public_path__ + "static/media/thumbnail.0fa07c4b.png";